import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
  Textarea,
  useToast,
  Select,
  RadioGroup,
  Stack,
  Radio,
} from "@chakra-ui/react";
import { useForm, Controller } from "react-hook-form";
import { useEffect, useCallback } from "react";
import moment from "moment";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  getDegree,
  getClasses_,
  getSpecification,
  createAnnouncement,
} from "../../redux/api_calls/apiCalls";
import * as yup from "yup";

// import { ReactComponent as AddPhoto } from "../../svg/AddPhoto.svg";

export default function AddAnnouncement() {
  const history = useHistory();

  const useYupValidationResolver = (validationSchema) =>
    useCallback(
      async (data) => {
        try {
          const values = await validationSchema.validate(data, {
            abortEarly: false,
          });

          return {
            values,
            errors: {},
          };
        } catch (errors) {
          console.log(errors);
          console.log(errors.inner);
          return {
            values: {},
            errors: errors.inner.reduce(
              (allErrors, currentError) => ({
                ...allErrors,
                [currentError.path]: {
                  type: currentError.type ?? "validation",
                  message: currentError.message,
                },
              }),
              {}
            ),
          };
        }
      },
      [validationSchema]
    );

  const validationSchema = yup.object({
    degree_id: yup.string().required("Degree is required"),
     class_id: yup.string().required("Year is required"),
    title: yup.string().required("Announcement title is required"),
    description: yup.string().required("Announcement Description is required"),
    session_for: yup.string().required("Session is required"),
    schedule_for: yup.string().required("Schedule is required"),
    start_date: yup.mixed().when("schedule_for", {
      is: "later",
      then: yup
        .date()
        .required("Start Date is Required")
        .nullable()
        .transform((v) => (v instanceof Date && !isNaN(v) ? v : null))
        .min(
          new Date(Date.now() - 86400000),
          "Start Date cannot be in the past"
        ),
    }),
    start_time: yup.mixed().when("schedule_for", {
      is: "later",
      then: yup
        .string()
        .required("Start Time is required")
        .test(
          "is-greater",
          "Start time should be greater than current time",
          function (value) {
            let start_date = this.parent.start_date
              ? new Date(
                  moment(this.parent.start_date).format("MM/DD/YYYY") +
                    " " +
                    value
                )
              : new Date();

            let result = moment(start_date).isAfter(new Date());

            return result;
          }
        ),
    }),
    end_date: yup
      .date()
      .required("End Date is Required")
      .nullable()
      .transform((v) => (v instanceof Date && !isNaN(v) ? v : null))
      .min(new Date(Date.now() - 86400000), "End Date cannot be in the past").when('start_date', (st, schema) => {
      
        if(st != null){
          st.setHours(st.getHours() + 1);
          console.log(schema,"st");
          return schema.min(st, 'End date must be later than start date')
        
         }else
          return schema.min('1900-01-01')

      }),
    end_time: yup
      .string()
      .required("End Time is required")
      .test(
        "is-greater",
        "End time should be greater than current time",
        function (value) {
          let end_date = this.parent.end_date
            ? new Date(
                moment(this.parent.end_date).format("MM/DD/YYYY") +
                  " " +
                  value
              )
            : new Date();

          let result = moment(end_date).isAfter(new Date());

          return result;
        }
      ),
  });

  const resolver = useYupValidationResolver(validationSchema);

  const {
    handleSubmit,
    register,
    control,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({ resolver });

  const [degree, setDegree] = useState([]);
  const [specification, setSpecification] = useState([]);
  const [classes, setClasses] = useState([]);

  let watchSchedulerFor = watch("schedule_for", "now");
  let watchDegree = watch("degree_id");

  const toast = useToast();
  const slider = useSelector((state) => state.sliderState.sliderOpen);

  useEffect(() => {
    loadFieldData();
  }, []);

  useEffect(() => {
    if (watchDegree) loadSpecification(watchDegree);
  }, [watchDegree]);

  const loadFieldData = async () => {
    let degree = await getDegree();
    setDegree(degree.payload || []);
    let classes = await getClasses_();
    setClasses(classes.payload.data || []);
  };

  const loadSpecification = async (degreeId) => {
    let specification = await getSpecification(degreeId);
    setSpecification(specification.payload || []);
  };

  const onSubmit = async (val) => {
    let fieldData = { ...val };
    fieldData.status = "Y";
    fieldData.end_date = moment(fieldData.end_date).format("YYYY/MM/DD");
    fieldData.end_time = moment(fieldData.end_time, ["HH", "MM"]).format(
      "hh:mm A"
    );

    if (fieldData.schedule_for === "now") {
      delete fieldData.start_date;
      delete fieldData.start_time;
    }

    if (fieldData.schedule_for === "later") {
      fieldData.start_date = moment(fieldData.start_date).format("YYYY/MM/DD");
      fieldData.start_time = moment(fieldData.end_time, ["HH", "MM"]).format(
        "hh:mm A"
      );
    }

    console.log(fieldData);

    let res = await createAnnouncement(fieldData);
    console.log({ res });
    if (res && res.code === 200) {
      toast({
        title: "Announcement Created Successfully!",
        description: "Announcement Created!",
        status: "success",
        duration: 1000,
        isClosable: true,
      });
      history.push("/announcements");
    } else {
      toast({
        title: "Something went wrong!",
        description: "Error!",
        status: "error",
        duration: 1000,
        isClosable: true,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box
        flexGrow="1"
        d="flex"
        justifyContent="flex-start"
        alignItems="center"
        flexDirection="column"
        minH="90vh"
        pl={[
          "0",
          "0",
          "0",
          slider ? (window.innerWidth < 1400 ? "18vw" : "13vw") : "7.5vw",
        ]}
        transition="all 350ms ease"
      >
        <Box
          width={["95%", "95%", "90%", "85%"]}
          justifyContent={["center", "center", "flex-start", "flex-start"]}
          alignItems={["center", "center", "flex-start", "flex-start"]}
          d="flex"
          mb="2rem"
          flexDirection="column"
        >
          <Text
            fontSize={["20px", "25px", "30px", "40px"]}
            d={["none", "none", "none", "flex"]}
            fontWeight="900"
            style={{ fontFamily: "Mulish, sans-serif" }}
            mb="2rem"
          >
            Add Announcement
          </Text>
          <Box
            width={["100%", "100%", "100%", "85%"]}
            justifyContent={["center", "center", "flex-start", "flex-start"]}
            alignItems={["center", "center", "flex-start", "flex-start"]}
            d="flex"
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
                width: "90%",
              }}
            >
              <FormControl
                isInvalid={errors.degree_id && errors.degree_id.message}
              >
                <FormLabel
                  variant="custom"
                  htmlFor="class_id"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Select Degree
                </FormLabel>
                <Select
                  width={["100%", "100%", "90%", "85%"]}
                  border="1px solid rgba(0, 0, 0, 0.1)"
                  borderRadius="13px"
                  height="40px"
                  fontSize="18px"
                  {...register("degree_id")}
                >
                  <option value="" disabled selected hidden>
                    Select a degree
                  </option>
                  {degree.map((item) => (
                    <option value={item.id} id={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize="sm">
                  {errors.degree_id && errors.degree_id.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl
                isInvalid={
                  errors.specification_id && errors.specification_id.message
                }
              >
                <FormLabel
                  variant="custom"
                  htmlFor="specification_id"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Select Specification
                </FormLabel>
                <Select
                  width={["100%", "100%", "90%", "85%"]}
                  border="1px solid rgba(0, 0, 0, 0.1)"
                  borderRadius="13px"
                  height="40px"
                  fontSize="18px"
                  {...register("specification_id")}
                >
                  <option value="" disabled selected hidden>
                    Select a specification
                  </option>
                  {specification.map((item) => (
                    <option value={item.id} id={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize="sm">
                  {errors.specification_id && errors.specification_id.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl
                isInvalid={errors.class_id && errors.class_id.message}
              >
                <FormLabel
                  variant="custom"
                  htmlFor="class_id"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Select Year
                </FormLabel>
                <Select
                  width={["100%", "100%", "90%", "85%"]}
                  border="1px solid rgba(0, 0, 0, 0.1)"
                  borderRadius="13px"
                  height="40px"
                  fontSize="18px"
                  {...register("class_id")}
                >
                  <option value="" disabled selected hidden>
                    Select a year
                  </option>
                  {classes.map((item) => (
                    <option value={item.id} id={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize="sm">
                  {errors.class_id && errors.class_id.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={errors.title && errors.title.message}>
                <FormLabel
                  variant="custom"
                  htmlFor="title"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Announcement Title
                </FormLabel>
                <Input
                  id="title"
                  width={["100%", "100%", "90%", "85%"]}
                  borderRadius="lg"
                  bgColor="white"
                  {...register("title")}
                />
                <FormErrorMessage fontSize="sm">
                  {errors.title && errors.title.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl
                isInvalid={errors.description && errors.description.message}
              >
                <FormLabel
                  variant="custom"
                  htmlFor="description"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                >
                  Announcement Description
                </FormLabel>
                <Textarea
                  id="description"
                  width={["100%", "100%", "90%", "85%"]}
                  borderRadius="lg"
                  bgColor="white"
                  rows="6"
                  resize="vertical"
                  {...register("description")}
                />
                <FormErrorMessage fontSize="sm">
                  {errors.description && errors.description.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl>
                <Controller
                  render={({ field }) => (
                    <RadioGroup {...field}>
                      <Stack direction="row" spacing={8}>
                        <Radio value="A">
                          For Teachers & Students
                        </Radio>
                        <Radio value="T">For Teachers Alone</Radio>
                      </Stack>
                    </RadioGroup>
                  )}
                  defaultValue="A"
                  name="session_for"
                  control={control}
                />
              </FormControl>
              <FormControl>
                <Controller
                  render={({ field }) => (
                    <RadioGroup {...field}>
                      <Stack direction="row" spacing={8}>
                        <Radio value="now">Schedule Now</Radio>
                        <Radio value="later">Schedule For Later</Radio>
                      </Stack>
                    </RadioGroup>
                  )}
                  defaultValue="now"
                  name="schedule_for"
                  control={control}
                />
              </FormControl>

              {watchSchedulerFor === "later" ? (
                <Box
                  width={["100%", "100%", "90%", "85%"]}
                  d="flex"
                  justifyContent="space-between"
                >
                  <Box width="45%">
                    <FormControl
                      isInvalid={errors.start_date && errors.start_date.message}
                    >
                      <FormLabel
                        variant="custom"
                        htmlFor="start_date"
                        style={{ fontFamily: "Mulish, sans-serif" }}
                      >
                        Start Date
                      </FormLabel>
                      <Input
                        type="date"
                        color="#666666"
                        width="100%"
                        border="1px solid rgba(0, 0, 0, 0.1)"
                        borderRadius="13px"
                        height="40px"
                        bgColor="white"
                        fontSize={["9px", "11px", "13px", "16px"]}
                        {...register("start_date", {
                          required: "Start date is required",
                        })}
                      />
                      <FormErrorMessage fontSize="sm">
                        {errors.start_date && errors.start_date.message}
                      </FormErrorMessage>
                    </FormControl>
                  </Box>
                  <Box width="45%">
                    <FormControl
                      isInvalid={errors.start_time && errors.start_time.message}
                    >
                      <FormLabel
                        variant="custom"
                        htmlFor="start_time"
                        style={{ fontFamily: "Mulish, sans-serif" }}
                      >
                        Start Time
                      </FormLabel>
                      <Input
                        type="time"
                        color="#666666"
                        width="100%"
                        border="1px solid rgba(0, 0, 0, 0.1)"
                        borderRadius="13px"
                        height="40px"
                        bgColor="white"
                        fontSize={["9px", "11px", "13px", "16px"]}
                        {...register("start_time", {
                          required: "Start date is required",
                        })}
                      />
                      <FormErrorMessage fontSize="sm">
                        {errors.start_time && errors.start_time.message}
                      </FormErrorMessage>
                    </FormControl>
                  </Box>
                </Box>
              ) : (
                <></>
              )}

              <Box
                width={["100%", "100%", "90%", "85%"]}
                d="flex"
                justifyContent="space-between"
              >
                <Box width="45%">
                  <FormControl
                    isInvalid={errors.end_date && errors.end_date.message}
                  >
                    <FormLabel
                      variant="custom"
                      htmlFor="end_date"
                      style={{ fontFamily: "Mulish, sans-serif" }}
                    >
                      End Date
                    </FormLabel>
                    <Input
                      type="date"
                      color="#666666"
                      id="end_date"
                      width="100%"
                      border="1px solid rgba(0, 0, 0, 0.1)"
                      borderRadius="13px"
                      height="40px"
                      bgColor="white"
                      fontSize={["9px", "11px", "13px", "16px"]}
                      {...register("end_date", {
                        required: "End Date is required",
                      })}
                    />
                    <FormErrorMessage fontSize="sm">
                      {errors.end_date && errors.end_date.message}
                    </FormErrorMessage>
                  </FormControl>
                </Box>
                <Box width="45%">
                  <FormControl
                    isInvalid={errors.end_date && errors.end_date.message}
                  >
                    <FormLabel
                      variant="custom"
                      htmlFor="end_time"
                      style={{ fontFamily: "Mulish, sans-serif" }}
                    >
                      End Time
                    </FormLabel>
                    <Input
                      type="time"
                      color="#666666"
                      id="end_time"
                      width="100%"
                      border="1px solid rgba(0, 0, 0, 0.1)"
                      borderRadius="13px"
                      height="40px"
                      bgColor="white"
                      fontSize={["9px", "11px", "13px", "16px"]}
                      {...register("end_time", {
                        required: "End Time is required",
                      })}
                    />
                    <FormErrorMessage fontSize="sm">
                      {errors.end_time && errors.end_time.message}
                    </FormErrorMessage>
                  </FormControl>
                </Box>
              </Box>

              <Box
                width={["100%", "100%", "90%", "85%"]}
                d="flex"
                flexDir={["column", "column", "row", "row"]}
                justifyContent={[
                  "center",
                  "center",
                  "flex-start",
                  "flex-start",
                ]}
                mt="2rem"
              >
                <Button
                  bgColor="#FE5858"
                  color="white"
                  borderRadius="lg"
                  p={["6px 15px", "8px 20px", "12px 30px"]}
                  _hover={{ bg: "#e44f48" }}
                  style={{ fontFamily: "Mulish, sans-serif" }}
                  fontWeight="800"
                  fontSize={["13px", "14px", "16px"]}
                  mr={["0", "0", "20px", "20px"]}
                  mb={["20px", "20px", "0", "0"]}
                  type="submit"
                  disabled={isSubmitting}
                >
                  Broadcast
                </Button>
                <Button
                  bgColor="white"
                  color="#999999"
                  borderRadius="lg"
                  border="1px solid rgba(0, 0, 0, 0.2)"
                  p={["6px 15px", "8px 20px", "12px 30px"]}
                  style={{ fontFamily: "Mulish, sans-serif" }}
                  fontWeight="800"
                  fontSize={["13px", "14px", "16px"]}
                  onClick={() => history.push("/announcements")}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </form>
  );
}
